
import React from 'react';
import './TableSubCategories.scss';
import { idQuizLoad, getIdSelectedSubCategory, openInputFormsForSubCategories, openDeleteInputFormsForSubCategories  } from '../../../../adminSlice.js';

export default class TableSubCategories extends React.Component {
    constructor(props) {
        super(props);

       // this.onGetAllQuizes = this.onGetAllQuizes.bind(this);
       this.onGetQuizes = this.onGetQuizes.bind(this);
       this.onEdit = this.onEdit.bind(this);
       this.onDelete = this.onDelete.bind(this);
    }

   //GET QUIZES BY ID
  
onGetQuizes(e) {
    const { dispatch } = this.props;
    //console.log("RRRRRRRRRRRR");
    //console.log(this.props.adminState.dataQuizes);
    const id= e.target.value ;
    
    console.log(id);
    dispatch(idQuizLoad(id));
    dispatch(getIdSelectedSubCategory(id));
    this.props.onClickSubcategory();
}
onEdit(e) {
    const { dispatch } = this.props;

    const id = e.target.value;
    console.log(id);
    dispatch(openInputFormsForSubCategories(id));

}
onDelete(e) {
    const { dispatch } = this.props;

    const id = e.target.value;
    console.log(id);
    dispatch(openDeleteInputFormsForSubCategories(id));

}
   renderTable() {
    let  data =  this.props.data;
    return (
        data.map(item => {
           // console.log(item.id + " " + item.label);
            return(
                
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        <td><button className='bigbtn'
                        onClick={this.onGetQuizes}
                        value={item.id}
                         >{item.text} <p className='public-item'>{item.public ? "public":""}</p> </button>
                         <div className='edit'>
                            <button className='smallbtnEdit' value={item.id} onClick={this.onEdit}></button>
                            <button className='smallbtnDelete' value={item.id} onClick={this.onDelete}></button>
                         </div>
                         </td>
                    </tr>
                    
                

                )
            })
        )    
   }
   
    render() {

        return(
            <div className="TableSubCategories">
                
                <table>
                    <thead>
                        <tr>
                            <th>№</th>
                            <th>Название подкатегории</th>
                        </tr>
                        
                    </thead>
                    <tbody>
                    {this.renderTable()}
                    
                    
                    </tbody>
                
                    
                    

                </table>
                
            </div>
        )
    }
}